<template>
<layout-content :title="`${editName}`">
  <template #body>
    <el-table
      ref="table"
      :data="list"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @selection-change="onSelectionChange"
      @row-click="onOpenEditor"
    >
      <el-table-column label="序号" width="50">
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column>

      <el-table-column prop="name" label="因子名称" />
      <el-table-column prop="unit" label="单位">
        <template slot-scope="{row}">
          {{row.unit ? row.unit : '--'}}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="{row}">
          {{row.status ? '已启用' : '未启用'}}
        </template>
      </el-table-column>
    </el-table>
  </template>
</layout-content>
</template>

<script>
import {DEVICE_SELECT_CHANGED} from './EventKeys'
import BaseListEditor from '../../../BaseListEditor'

export default {
  name: 'DeviceStatus',
  extends: BaseListEditor,
  computed: {
    apiKey () {
      return 'DeviceStatus'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return '设备状态'
    }
  },
  methods: {
    onDeviceSelectChanged (device) {
      let {id: deviceId} = device

      if (!deviceId) {
        this.device = null
        this.list = []
        return
      }

      device = this.device = Object.freeze(JSON.parse(JSON.stringify(device)))
      this.query.deviceId = deviceId
      this.getList()
    }
  },
  created () {
    this.$eventBus.on(DEVICE_SELECT_CHANGED, this.onDeviceSelectChanged)
  },
  beforeDestroy () {
    this.$eventBus.off(DEVICE_SELECT_CHANGED, this.onDeviceSelectChanged)
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/03Device/DeviceStatus.vue